import React, { useRef } from 'react';
import { useFrame } from '@react-three/fiber';
import { Text as DreiText } from '@react-three/drei';

const DocumentModel = (props) => {
  const { isDarkMode = false, ...restProps } = props;
  const documentRef = useRef();
  const pagesRef = useRef([]);

  useFrame((state) => {
    if (documentRef.current) {
      documentRef.current.rotation.x = Math.sin(state.clock.elapsedTime * 0.2) * 0.1;
      documentRef.current.rotation.z = Math.cos(state.clock.elapsedTime * 0.3) * 0.05;
    }

    pagesRef.current.forEach((page, i) => {
      if (page) {
        page.rotation.z = Math.sin(state.clock.elapsedTime * 0.5 + i) * 0.02;
      }
    });
  });

  return (
    <group {...restProps}>
      <mesh ref={documentRef} castShadow>
        <boxGeometry args={[1.2, 1.6, 0.1]} />
        <meshStandardMaterial
          color={isDarkMode ? "#1a365d" : "#2d3748"}
          metalness={isDarkMode ? 0.3 : 0.2}
          roughness={isDarkMode ? 0.4 : 0.6}
        />
      </mesh>

      {[0, 1, 2].map((i) => (
        <mesh
          key={i}
          ref={(el) => (pagesRef.current[i] = el)}
          position={[0, 0, 0.05 + i * 0.01]}
          castShadow
        >
          <planeGeometry args={[1.15, 1.55]} />
          <meshStandardMaterial
            color={isDarkMode ? "#f7fafc" : "#ffffff"}
            side={2}
            metalness={isDarkMode ? 0.1 : 0.05}
            roughness={isDarkMode ? 0.8 : 0.9}
          />
        </mesh>
      ))}

      <DreiText
        position={[0, 0.3, 0.06]}
        fontSize={0.15}
        color="#A37A00"
        anchorX="center"
        anchorY="middle"
      >
        FINANCIAL
      </DreiText>
      <DreiText
        position={[0, 0.1, 0.06]}
        fontSize={0.15}
        color="#A37A00"
        anchorX="center"
        anchorY="middle"
      >
        REPORT
      </DreiText>
      <DreiText
        position={[0, -0.2, 0.06]}
        fontSize={0.08}
        color="#A37A00"
        anchorX="center"
        anchorY="middle"
      >
        M.A.S ELITE
      </DreiText>

      <DreiText
        position={[0, 0.5, 0.09]}
        fontSize={0.04}
        color={isDarkMode ? "#2d3748" : "#4a5568"}
        anchorX="center"
        maxWidth={1}
        textAlign="center"
      >
        Quarterly Financial Analysis
      </DreiText>
      
      <DreiText
        position={[0, 0.3, 0.09]}
        fontSize={0.03}
        color={isDarkMode ? "#4a5568" : "#718096"}
        anchorX="center"
        maxWidth={1}
        textAlign="center"
      >
        Revenue Growth: +24.5%
        \nProfit Margin: 18.2%
        \nTax Efficiency: 94.7%
      </DreiText>

      {[0, 1, 2, 3].map((i) => (
        <mesh
          key={`number-${i}`}
          position={[
            -0.4 + (i % 2) * 0.8,
            0.6 - Math.floor(i / 2) * 0.4,
            0.12 + i * 0.01
          ]}
        >
          <DreiText
            fontSize={0.05}
            color="#A37A00"
            opacity={isDarkMode ? 0.7 : 0.8}
            anchorX="center"
            anchorY="middle"
          >
            {['$', '%', '↑', '✓'][i]}
          </DreiText>
        </mesh>
      ))}

      <mesh position={[0, 0, 0.055]}>
        <planeGeometry args={[1.25, 1.65]} />
        <meshBasicMaterial
          color="#A37A00"
          transparent
          opacity={isDarkMode ? 0.1 : 0.05}
          side={2}
        />
      </mesh>
    </group>
  );
};

export default DocumentModel;